


















































































































































































































































































































import {Vue, Component} from 'vue-property-decorator';
import {getImage, Utils} from '@/utils/Utils';
import {API, BASE_URL} from '@/services/api/api';
import {mapActions} from 'vuex';
import {findDeckMarkerInDeckImg} from '@/utils/DeckOperations';
import {extractDetailsFromBase64} from '@/services/api/image';
import {redirectTime, acceptedImageTypes} from '@/constants/constants';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import canvasMerge from '@/utils/CanvasMerge';
import VueWorker from 'vue-worker';

Vue.use(VueWorker);

@Component({
  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast', 'setupAppData']),
  },
})
export default class CreateShip extends Vue {
  // form variables
  shipName = '';
  shipImageName = '';
  shipImageURL = '';
  deckImageName = '';
  deckImageURL = '';
  shipStatus = false;
  shipImagebase64URL: any;
  newShipImage: any = '';
  newShipImageType: any = '';
  newShipImageName: any = '';
  commentOnShip = '';
  isActive1 = true;
  isActive2?: boolean;
  enable1 = true;
  enable2?: boolean;
  deckLength = 0;
  imageValidationMsg = '';
  shipValidationMsg = '';
  deckCanvasImg: any;
  focusedIndex = null;
  createdDeckImageUrl = null;
  createdShipImage = '';
  shipImgLoader: Boolean = false;

  //validation variables
  commonValidationMsg = 'This field is required';
  addIcon = require('@/assets/images/add-img.png');
  comment = '';
  deckNameValidationMsg = '';
  fileNameValidationMsg = '';

  BASE_URL() {
    return BASE_URL;
  }

  //deck data array
  deckData: any = [
    {
      drawingId: null,
      name: '',
      fileName: '',
      imageHeight: null,
      imgaeWidth: null,
      bottomX: null,
      topX: null,
      bottomY: null,
      topY: null,
      height: null,
      width: null,
      deckNameValidationMsg: '',
      fileNameValidationMsg: '',
      heightValidationMsg: '',
    },
  ];
  //other variables
  isScreenLoading = true;
  showSuccessToast: any;
  showErrorToast: any;
  setupAppData: any;
  shipId = Number(this.$route.params.id);
  cropper = null;
  startY = 0;
  MarkerWidth = 5;
  endX: any;
  endY: any;
  acceptedImageTypes = acceptedImageTypes;
  loadingBtnStatus = false;
  deck: null;
  shipDots = [];
  howercontectText = '';
  shipList = [];
  deckDots = [];

  startX = this.MarkerWidth;
  myCanvasStyle = {
    height: 20,
    width: 20,
  };
  originalDeckList = [];
  decks = [];
  inspectionList: [];

  mounted() {
    this.getShipDataById();
    this.fetchInspectionListByShip();
    this.$nextTick(() => {
      this.deckCanvasImg = new Image();
      this.deckCanvasImg.setAttribute('crossOrigin', 'Anonymous');
      this.deckCanvasImg.onload = this.onDeckLoad;
    });
  }

  getToolTipImage(imagePath: string, imageType: string) {
    if (imagePath.length === 36) return '';
    return imagePath.startsWith('data:image') ? imagePath : `data:image/${imageType};base64,${imagePath}`;
  }

  // get ship by id convert image into blob then base64
  async getShipDataById() {
    try {
      const params = {
        alldecks: 1,
        withoutzones: 0,
        withoutcenter: 0,
      };

      const response = await API.fetchEmptyDecksByShipId(params, this.shipId);

      if (response.data) {
        const data = response.data;

        this.shipName = data.name;

        this.shipStatus = data.isActive;
        this.comment = data.comments;
        this.shipImageName = data.fileName;
        this.shipImageURL = await getImage(data.imagePath);
        const decks = data.drawings;

        if (decks.length > 0) {
          this.deckData = decks;
          await Promise.all(
            this.deckData.map(async (deck: any) => {
              if (deck.imagePath.length > 38) {
                console.error('image path length is greater than 38', deck);
                return;
              }
              deck.imagePath = await getImage(deck.imagePath);
            })
          );

          this.originalDeckList = decks;
        } else {
          this.deckData = [];
          this.originalDeckList = [];
        }
      } else {
        this.deckData = [];
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network Error'});
      console.error(error);
    } finally {
      this.isScreenLoading = false;
    }
  }

  async fetchInspectionListByShip() {
    try {
      this.inspectionList = [];
      this.isScreenLoading = true;
      const param = {
        ShipId: this.shipId,
      };
      const response = await API.getInspectionListByShip(param);
      if (response.data) {
        this.inspectionList = response.data;
        // this.renderDot;

        //
      } else if (response.errors) {
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.showErrorToast({msg: 'Network error'});
      }
      //
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  //cropbox auto initialize after image load
  onDeckLoad() {
    this.myCanvasStyle = {
      height: this.deckCanvasImg.height,
      width: this.deckCanvasImg.width,
    };
  }

  //scan ship  image for automatic getting height etc
  scanImage(deck) {
    const _this = this;

    _this.isScreenLoading = true;

    setTimeout(function () {
      try {
        const shipImage = _this.$refs.deckImageOnCanvas as HTMLCanvasElement;
        const context = shipImage.getContext('2d');
        context.drawImage(
          _this.deckCanvasImg,
          0,
          0,
          _this.deckCanvasImg.naturalWidth,
          _this.deckCanvasImg.naturalHeight
        );

        //

        return _this.scanFullImage();
      } catch (error) {
        console.error({error});

        _this.showErrorToast({
          msg: 'Something went wrong .',
        });
      } finally {
        _this.isScreenLoading = false;
      }
    }, 1000);
  }

  //scan image on canvas to find center point , zone , frame
  scanFullImage() {
    const deckImageOnCanvas: any = this.deckCanvasImg;
    this.startX = 0;
    this.endX = deckImageOnCanvas.width;
    // set center 20% height to scan
    this.startY = parseInt('' + deckImageOnCanvas.height * 0.45);
    this.endY = parseInt('' + deckImageOnCanvas.height * 0.55);

    const ShipImage = this.$refs.deckImageOnCanvas as HTMLCanvasElement;

    const response =
      // this.$worker.run(

      findDeckMarkerInDeckImg(this.deckCanvasImg, ShipImage, this.startX, this.endX, this.startY, this.endY, false);
    // );

    const deckImageScanResult = JSON.stringify(response);
    const index = this.deckData.findIndex((data) => data === this.deck);

    let {Deck, Zones, Frames, Center} = response;

    if (Deck) {
      if ((Deck.StartPoint.X === 0 && Deck.StartPoint.Y === 0) || (Deck.EndPoint.X === 0 && Deck.EndPoint.Y === 0))
        return this.showErrorToast({
          msg: 'Deck markers not found on this image',
        });
      else if (Zones?.length > 0) var zone = Zones[0];

      if (
        zone.Zone.ZoneNumber === 0 &&
        zone.Zone.StartPoint.X === 0 &&
        zone.Zone.StartPoint.Y === 0 &&
        zone.Zone.EndPoint.X === 0 &&
        zone.Zone.EndPoint.Y === 0
      ) {
        return this.showErrorToast({
          msg: 'Zones markers not found on this deck image',
        });
      } else if (Frames.length > 0) {
        var frame = Frames[0];
        if (
          frame.Frame.FrameNumber === 0 &&
          frame.Frame.FrameNumber === 0 &&
          frame.Frame.StartPoint.X === 0 &&
          frame.Frame.StartPoint.Y === 0 &&
          frame.Frame.EndPoint.X === 0 &&
          frame.Frame.EndPoint.Y === 0
        ) {
          return this.showErrorToast({
            msg: 'Frames markers not found on this deck image',
          });
        } else {
          const index = this.deckData.findIndex((data) => data === this.deck);

          this.deckData[index].scanResult = deckImageScanResult;
          this.deckData[index].imageHeight = deckImageOnCanvas.height;
          this.deckData[index].imageWidth = deckImageOnCanvas.width;
        }
      }
    }
  }

  //validate data
  validateAll() {
    return this.validateShipName() && this.validateDeckData();
  }

  //handle update ship
  async updateHandler() {
    if (!this.validateShipName()) return;
    else {
      let shipImgRef = this.$refs.shipImageRef as HTMLImageElement;
      this.loadingBtnStatus = true;

      const params = {
        name: this.shipName,
        comments: this.comment,
        isActive: this.shipStatus,
        fileName: null,
        imageType: null,
        imagePath: null,
        drawing: [],
        imageWidth: shipImgRef.naturalWidth,
        imageHeight: shipImgRef.naturalHeight,
      };
      if (this.newShipImage) {
        params.imagePath = this.newShipImage.split(',')[1];
        params.imageType = this.newShipImageType;
        params.fileName = this.newShipImageName;
      }

      try {
        const response = await API.updateShipById(this.shipId, params);

        if (response.data) {
          this.showSuccessToast({msg: response.message});
          setTimeout(() => this.backHandler(), redirectTime);
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        console.error(error);
        this.showErrorToast({msg: 'Network Error'});
        console.error(error);
      } finally {
        this.loadingBtnStatus = false;
      }
    }
  }

  //validate deck array
  validateDeckData() {
    let isFieldsValid: boolean;
    this.deckData.some((deck) => {
      if (deck.name === '' || deck.name.length < 1) {
        deck.deckNameValidationMsg = this.commonValidationMsg;
        isFieldsValid = false;
        return true;
      } else {
        deck.deckNameValidationMsg = '';
        isFieldsValid = true;
      }
      if (deck.fileName === '' || deck.fileName.length < 1) {
        deck.fileNameValidationMsg = this.commonValidationMsg;
        isFieldsValid = false;

        return true;
      } else {
        deck.fileNameValidationMsg = '';

        isFieldsValid = true;
      }
      if (!deck.bottomX || !deck.topX || !deck.bottomY || !deck.topY || !deck.height || !deck.width) {
        deck.heightValidationMsg = this.commonValidationMsg;
        isFieldsValid = false;

        return true;
      } else {
        deck.heightValidationMsg = '';
        isFieldsValid = true;
      }
    });
    this.$forceUpdate();
    if (isFieldsValid) {
      if (this.checkSameValue()) {
        isFieldsValid = false;
      }
    }
    return isFieldsValid;
  }

  // handling file upload for deck , then convert ro base64 to render image on canvas and to find center point , zones , frames
  async onFileChange(event: any, deck: any) {
    const imageData = event.target.files[0];
    let imgSizeInByte: number = imageData.size;
    let limitInKB = 8388608;

    if (limitInKB < imgSizeInByte) {
      this.showErrorToast({
        msg: 'Image can not be larger than 8 MB.',
      });
      event.target.value = '';
    } else {
      this.isScreenLoading = true;

      this.deck = deck;
      const index = this.deckData.findIndex((data) => data === this.deck);

      try {
        let base64url = await Utils.ngxBase64(imageData);

        if (base64url === null || base64url === '') {
          this.showErrorToast({msg: 'Something went wrong with image'});
        } else {
          this.deckCanvasImg.src = base64url;
          if (this.deckCanvasImg.src !== '') {
            this.deckData[index].fileName = imageData.name;
            const {url, imageType} = extractDetailsFromBase64(base64url);
            this.deckData[index].imagePath = url;
            this.deckData[index].imageType = imageType;
            this.scanImage(this.deck);
            deck.fileNameValidationMsg = '';
          }
        }
      } catch (error) {
        this.isScreenLoading = false;

        return 'something went wrong';
      }
    }
  }

  // handling file upload for deck , then convert ro base64 to render image on canvas and to find center point , zones , frames
  async onFileChangeShip(event: any) {
    this.isScreenLoading = true;
    const imageData = event.target.files[0];
    try {
      let base64url = await Utils.ngxBase64(imageData);

      if (base64url === null || base64url === '') {
        this.showErrorToast({msg: 'Something went wrong with image'});
      } else {
        if (base64url !== '') {
          this.newShipImage = base64url;
          this.newShipImageType = extractDetailsFromBase64(base64url).imageType;
          this.newShipImageName = imageData.name;
          this.isScreenLoading = false;
        }
      }
    } catch (error) {
      this.isScreenLoading = false;

      this.showErrorToast({msg: 'Something went wrong with image'});
    }
  }

  //add empty deck in array
  public addDeck(deckLength: number) {
    if (deckLength === 0 || this.validateDeckData()) {
      this.deckData.push({
        drawingId: null,
        name: '',
        deckNameValidationMsg: '',
        fileName: '',
        fileNameValidationMsg: '',
        bottomX: null,
        topX: null,
        bottomY: null,
        topY: null,
        height: null,
        width: null,
        heightValidationMsg: '',
        imagePath: '',
        imageType: '',
        scanResult: null,
        isDeckSaved: false,
      });
    }
  }

  //validate ship Name
  validateShipName() {
    if (this.shipName === null || this.shipName.toString().length < 1) {
      this.shipValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.shipValidationMsg = '';
      return true;
    }
  }

  // delete deck from local and server
  async recalculateDeckZones(deck: any) {
    this.deck = deck;
    const index = this.deckData.findIndex((data) => data === deck);
    this.deckCanvasImg.src = deck.imagePath;
    this.scanImage(deck);
  }

  async deleteDeck(deck: any) {
    if (!deck.drawingId) {
      const index = this.deckData.findIndex((data) => data === deck);
      if (index !== -1) {
        this.deckData.splice(index, 1);
      }
    } else {
      try {
        this.isScreenLoading = true;
        const response = await API.deleteDeckById(deck.drawingId);

        if (response.message) {
          this.getShipDataById();
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        this.isScreenLoading = false;
        this.showErrorToast({msg: 'Network error'});
        console.error(error);
      } finally {
        // this.isScreenLoading = false;
      }
    }
  }

  checkSameValue() {
    let dublicate = false;
    this.deckData.map((deck1, index1) => {
      if (!dublicate) {
        dublicate = this.deckData.some((deck2, index2) => {
          if (index1 !== index2 && deck1.name == deck2.name) {
            deck2.deckNameValidationMsg = 'Name for the 2 decks cannot be same.';
            return true;
          }

          if (
            index1 !== index2 &&
            deck1.bottomX == deck2.bottomX &&
            deck1.topX == deck2.topX &&
            deck1.bottomY == deck2.bottomY &&
            deck1.topY == deck2.topY &&
            deck1.height == deck2.height &&
            deck1.width == deck2.width
          ) {
            deck2.heightValidationMsg = 'Values for the 2 decks cannot be same.';
            return true;
          }
        });
      }
    });
    return dublicate;

    // return this.deckData.some((d, i) => {
    //   if (
    //     i !== index &&
    //     deck.bottomX == d.bottomX &&
    //     deck.topX == d.topX &&
    //     deck.bottomY == d.bottomY &&
    //     deck.topY == d.topY &&
    //     deck.height == d.height &&
    //     deck.width == d.width
    //   ) {
    //     return true;
    //   }
    // });
  }

  // save deck data in individually
  async saveDeck(deck) {
    if (this.checkSameValue()) {
      return false;
    }
    if (deck.name === '' || deck.name.length < 1) {
      deck.deckNameValidationMsg = this.commonValidationMsg;

      return false;
    } else {
      deck.deckNameValidationMsg = '';
    }
    if (deck.fileName === '' || deck.fileName.length < 1) {
      deck.fileNameValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      deck.fileNameValidationMsg = '';
    }
    if (!deck.bottomX || !deck.topX || !deck.bottomY || !deck.topY || !deck.height || !deck.width) {
      deck.heightValidationMsg = this.commonValidationMsg;

      return true;
    } else {
      deck.heightValidationMsg = '';

      this.isScreenLoading = true;

      const {deckNameValidationMsg, fileNameValidationMsg, heightValidationMsg, isDeckSaved, ...newDeck} = deck;

      newDeck.shipId = this.shipId;
      newDeck?.drawingId === null ? delete newDeck.drawingId : newDeck;

      try {
        const response = await API.addOrUpdateDeck(newDeck);

        if (response.data) {
          this.showSuccessToast({msg: response.message});
          this.getShipDataById();
        } else {
          // this.deckData = [];
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        console.error(error);

        this.showErrorToast({msg: 'Network Error'});
      } finally {
        this.isScreenLoading = false;
      }
    }
  }

  //back handler
  backHandler() {
    this.setupAppData();
    this.$router.go(-1);
  }

  onShipLoad() {
    let _this = this;

    this.shipImgLoader = true;
    this.renderDot();

    window.onmousemove = function (e) {
      const main = e.target as HTMLImageElement;
      if (main.classList.contains('shipimg')) {
        //	Content of dot which is hovered
        const $target = main.nextElementSibling as HTMLElement;
        //

        //	Only work with hovered target
        //	Add visible class hovered elem to distinguish
        if (!$target.classList.contains('visible')) {
          $target.classList.add('visible');
        } else {
          //	Get viewport offset of tooltip element
          let offset = $target.parentElement.getBoundingClientRect();
          //	Tooltip distance from mouse(px)
          let tipDist = 15;
          //	Calc and set new tooltip location
          $target.style.top = e.clientY - offset.top + tipDist + 'px';
          $target.style.left = e.clientX - offset.left + tipDist + 'px';

          offset = main.getBoundingClientRect();
          let x = e.clientX - offset.left;
          let y = e.clientY - offset.top;
          let cw = main.clientWidth;
          let ch = main.clientHeight;
          let iw = main.naturalWidth;
          let ih = main.naturalHeight;
          let posx = (x / cw) * iw;
          let posy = (y / ch) * ih;

          let detactMouse = false;
          _this.shipDots.map((dots) => {
            if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.003 * main.naturalWidth) {
              //
              _this.howercontectText =
                'Click here to view inspection : ' + dots.inspectionCode + ' (ID: ' + dots.inspectionID + ')';
              main.style.cursor = 'pointer';
              detactMouse = true;
            }
          });

          if (!detactMouse) {
            const ship = _this.shipList.find((me) => {
              return me.shipId === _this.shipId;
            });

            const decks = ship.drawing;

            const deck = decks.find((d) => d.topY <= posy && posy <= d.bottomY);
            if (deck) {
              _this.howercontectText = 'Click here to view inspection of deck: ' + deck.name;
              main.style.cursor = 'unset';
            } else {
              _this.howercontectText = '';
              main.style.cursor = 'unset';
            }
          }
        }
      } else if (main.classList.contains('deckimg')) {
        //	Content of dot which is hovered
        let imageRef = _this.$refs.deckImageRef as HTMLImageElement;
        let offset = imageRef.getBoundingClientRect();
        let x = e.clientX - offset.left;
        let y = e.clientY - offset.top;
        let cw = main.clientWidth;
        let ch = main.clientHeight;
        let iw = main.naturalWidth;
        let ih = main.naturalHeight;
        let posx = (x / cw) * iw;
        let posy = (y / ch) * ih;

        let detactMouse = false;
        _this.deckDots.map((dots) => {
          if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.005 * main.naturalWidth) {
            //
            _this.howercontectText =
              'Click here to view inspection : ' + dots.inspectionCode + ' (ID: ' + dots.inspectionID + ')';
            main.style.cursor = 'pointer';
            detactMouse = true;
          }
        });
        if (!detactMouse) {
          main.style.cursor = 'unset';
          _this.howercontectText = '';
        }
      } else {
        //	Remove visible class
        var content = document.getElementsByClassName('hovercontent');
        for (var i = 0; i < content.length; i++) {
          content[i].classList.remove('visible');
        }
      }
    };
  }

  renderDot() {
    this.shipDots = [];
    if (this.shipImgLoader && this.shipImageURL && this.inspectionList.length > 0) {
      let imageRef = this.$refs.shipImageRef as HTMLImageElement;
      this.inspectionList.map((inspection: any) => {
        //

        const points = inspection.additionalInfo;
        let y = (points.deckTopY + points.deckBottomY) / 2;
        let totalFrame = points.frameUpto - points.frameFrom;
        let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
        let pixelsInEachframes = pixelsCountInZone / totalFrame;
        let thisframePosition = points.frameUpto - inspection.frameNumber;

        let deckWidth = inspection.deckImageWidth;
        let deckHeight = inspection.deckImageHeight;
        let shipHeight = inspection.shipImageHeight;
        let shipWidth = inspection.shipImageWidth;

        //
        //   points.zoneStartPoint,
        //   thisframePosition,
        //   pixelsInEachframes,
        //   inspection.inspectionCode
        // );

        //
        //   deckWidth,
        //   deckHeight,
        //   shipHeight,
        //   shipWidth,
        // });

        let framePosition = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
        //
        //   y,
        //   framePosition,
        //   totalFrame,
        //   pixelsCountInZone,
        //   pixelsInEachframes,
        //   points,
        // ]);

        let widthPoint = (shipWidth / deckWidth) * framePosition;
        let heightPoint = y;
        //
        //   deckWidth,
        //   deckHeight,
        //   shipHeight,
        //   shipWidth,
        //   framePosition,
        //   widthPoint,
        //   heightPoint,
        // });

        this.shipDots.push({
          x: widthPoint,
          y: heightPoint,
          radius: 0.003 * imageRef.naturalWidth,
          color: Utils.getBackgroundColor(inspection.severity),
          inspectionID: inspection.inspectionID,
          inspectionCode: inspection.inspectionCode,
        });
      });
      this.mergeImage();
    } else {
      this.handleCropper();
      this.shipImgLoader = false;
    }
  }

  //make a copy of zone lines and orignal image
  mergeImage(type = 1) {
    let img = this.newShipImage || this.shipImageURL;
    let dots = this.shipDots;

    canvasMerge(img, dots, {
      crossOrigin: 'anonymous',
      drawType: 'circle',
    }).then((b64) => {
      if (type == 2) {
        this.createdDeckImageUrl = b64;
        this.shipImgLoader = false;
        this.handleCropper();
      } else {
        this.createdShipImage = b64;
        this.shipImgLoader = false;
        this.handleCropper();
      }
    });
  }

  // on shipload calculate height params automatic
  handleCropper() {
    this.destroyCropper();
    const t = this.$refs.shipImageRef as HTMLImageElement;
    const _this = this;
    this.cropper = new Cropper(t, {
      autoCrop: false,
      crop() {
        const data = this.cropper.getData(true);
        const index = _this.deckData.length;
        if (_this.focusedIndex != null) {
          _this.deckData[_this.focusedIndex].bottomX = data.x + data.height;
          _this.deckData[_this.focusedIndex].bottomY = data.y + data.height;
          _this.deckData[_this.focusedIndex].topX = data.x;
          _this.deckData[_this.focusedIndex].topY = data.y;
          _this.deckData[_this.focusedIndex].height = data.height;
          _this.deckData[_this.focusedIndex].width = data.width;
        } else {
          _this.deckData[index - 1].bottomX = data.x + data.height;
          _this.deckData[index - 1].bottomY = data.y + data.height;
          _this.deckData[index - 1].topX = data.x;
          _this.deckData[index - 1].topY = data.y;
          _this.deckData[index - 1].height = data.height;
          _this.deckData[index - 1].width = data.width;
        }
      },
      preview: document.getElementById('ppppp'),
      zoomable: false,
      viewMode: 2,
    });
  }

  //destroy crop box cropper
  destroyCropper() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  //re-initialize cropper
  _reseImage() {
    if (this.cropper) {
      this.cropper.reset();
      this.newShipImage = '';
      this.newShipImageType = '';
      this.newShipImageName = '';
    }
  }

  //focus cursor on input box
  focusOnIndex(index) {
    this.focusedIndex = index;
  }

  //focus out cursor from input box
  blurOnIndex(index) {
    if (this.focusedIndex === index) {
      this.focusedIndex = null;
    }
  }
}
